import { instance as axios, setJwtToken } from "../../config/axiosInstance";

const BASE = "/admin/v1/session";

// Full breakdown for a single consultation session
export const fetchSessionBreakdownApi = async (sessionId) => {
  return await axios.get(`${BASE}/${sessionId}/breakdown`, setJwtToken());
};

// Admin-wide coupon/offer analytics
export const fetchCouponOfferAnalyticsApi = async (params = {}) => {
  const query = new URLSearchParams({ ...params }).toString();
  return await axios.get(`${BASE}/analytics/coupon-offer?${query}`, setJwtToken());
};

// Consultant-specific analytics (used by consultant app proxy or admin view)
export const fetchConsultantCouponAnalyticsApi = async (consultantId, params = {}) => {
  const query = new URLSearchParams({ consultantId, ...params }).toString();
  return await axios.get(`${BASE}/analytics/consultant-coupon?${query}`, setJwtToken());
};
